import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import 'app/components/Link/Link.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function Link({
  bold = false,
  size = '',
  fontWeight = '',
  style = {},
  href = '',
  text,
  tooltipText = '',
  target = '_self'
}) {
  const link = (
    <a
      href={href}
      className={classNames(`${size} ${fontWeight}`, {
        bold
      })}
      style={style}
      target={target}
    >
      {text}
    </a>
  );

  if (tooltipText) {
    return (
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip>{tooltipText}</Tooltip>}
        trigger={['hover', 'focus', 'click']}
      >
        <div>{link}</div>
      </OverlayTrigger>
    );
  }

  return link;
}

Link.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['', 'small', 'big']),
  fontWeight: PropTypes.oneOf(['', 'medium', 'bold', 'regular']),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  bold: PropTypes.bool,
  href: PropTypes.string,
  tooltipText: PropTypes.string,
  target: PropTypes.string
};
